import React, { useState, useEffect, useRef } from "react";
import { useNavigate, NavLink, useParams } from "react-router-dom";
import axios from "axios";
import { FaFilter } from "react-icons/fa";
import { MdArrowOutward } from "react-icons/md";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import "./Productlist.css";
import image from "./../../images/img1.png";
import Mainlayout from "../../components/Mainlayout";
import { GrFormClose } from "react-icons/gr";
import { useLocation } from "react-router-dom";
import { useStepContext } from "@mui/material";
import ImageOnLeft from "../../components/imageOnLeft/ImageOnLeft";
import ImageOnTop from "../../components/imageOnTop/ImageOnTop";
import ListView from "../../components/listView/ListView";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import ViewModuleIcon from "@mui/icons-material/ViewModule"; // Icon for Grid View
import ViewListIcon from "@mui/icons-material/ViewList"; // Icon for List View
import { Canvas, useLoader } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import { OBJLoader } from "three-stdlib";
import { Button } from "@mui/material";
import AppBreadcrumbs from "../../components/breadcrumbs/AppBreadcrumbs";
import { compareState } from "../../store/CompareState";
import { useRecoilState } from "recoil";
import MyButton from "../../components/button/MyButton";
import MyButtonGroup from "../../components/button/MyButtonGroup";
import styled from 'styled-components';
import MySelect from "../../components/select/MySelect";
import { FaSort } from "react-icons/fa"; // Import sort icon

const style = (top, left) => ({
  position: "absolute",
  top: top - 150,
  left: left,
  width: 800,
  backgroundColor: "white",
  border: "1px solid #000",
  boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
  padding: "16px",
  overflowY: "scroll",
  maxHeight: "80vh",
});

const Accordian = styled.div`
  background-color: #fff;
  position: relative;
  background-color: white;
  border: 1px solid rgba(99, 98, 102, 1);
  margin: 7px 0px 10px 8px;
  padding: 10px;
  width: ${window.ENV.FILTER_WIDTH};
  color : #212529;
  border-radius: 8px;
`;

// Mobile Filter Components
const MobileFilterContainer = styled.div`
 position: fixed;
 bottom: 0;
 left: 0;
 right: 0;
 background: white;
 z-index: 1000;
 box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
 transition: transform 0.3s ease-in-out;
 transform: ${({ open }) => open ? 'translateY(0)' : 'translateY(100%)'};
 max-height: 80vh;
 overflow-y: auto;
`;

const MobileFilterHeader = styled.div`
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 15px;
 border-bottom: 1px solid #eee;
 background: white;
 position: sticky;
 top: 0;
 z-index: 10;
`;

const MobileFilterContent = styled.div`
 padding: 15px;
 padding-bottom: 80px;
`;

const MobileFilterFooter = styled.div`
 position: sticky;
 bottom: 0;
 background: white;
 padding: 15px;
 border-top: 1px solid #eee;
 display: flex;
 justify-content: space-between;
 gap: 15px;
 
 button {
  flex: 1;
  padding: 12px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  font-family: 'Kaisei Opti', serif;
  
  &:first-child {
   background: #f5f5f5;
   color: #333;
  }
  
  &:last-child {
   background: #f5f5f5;
   color: #333;
  }
 }
`;

const Productlist = ({ productData: propProductData, error: productError }) => {
  const { itemName } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const searchQuery = searchParams.get('search');
  console.log("searchQuery", searchQuery);
  console.log("itemName", itemName);
  console.log("location.search", location.search);
  console.log("location.pathname", location.pathname);
  
  const [localProductData, setLocalProductData] = useState(
    propProductData || []
  );
  const [filteredProductData, setFilteredProductData] = useState(
    propProductData || []
  );
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [compareProducts, setCompareProducts] = useRecoilState(compareState);
  const [filter, setFilter] = useState([]);
  const [error, setError] = useState(null);
  const [showButtons, setShowButtons] = useState({});
  const [showMoreState, setShowMoreState] = useState({});
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [modalState, setModalState] = useState("");
  const buttonRef = useRef(null);
  const [isgrid, setIsgrid] = useState(true);
  const [selectedOption, setSelectedOption] = useState("1");
  const dataKey = window.ENV.GOOGLE_SHEET_ID;

  // Mobile filter state
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
  const [mobileSortOpen, setMobileSortOpen] = useState(false); // New state for mobile sort
  const [activeMobileFilter, setActiveMobileFilter] = useState(null);
  const filterRefs = useRef({});
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);

  // Add at the top of the Productlist component, after other useState hooks
  const [tempSelectedSort, setTempSelectedSort] = useState(selectedOption);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1024);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Function to fetch filter options (used on initial load)
  useEffect(() => {
    const fetchFilterOptions = async () => {
      const url1 = `${API_URL}/${window.ENV.TENANT_NAME}/${window.ENV.DATA_SOURCE}/filter`;
      const requestBodyFilter = {
        range: "Product!A1:" + window.ENV.TOTAL_PRODUCTS,
        dataKey: dataKey,
        filterName: "categoryName",
        filterValue: itemName,
      };

      try {
        const response = await axios.post(url1, requestBodyFilter, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        const sortedData = response.data.map((item) => ({
          ...item,
          options: item.options
            .slice()
            .sort((a, b) => parseFloat(a.value) - parseFloat(b.value)),
        }));
        setFilterData(sortedData);
      } catch (error) {
        const errorMessage = error.response
          ? error.response.data.message
          : error.message;
        setError(errorMessage || "An error occurred while fetching filter data.");
      }
    };
    fetchFilterOptions();
    setFilter([]); // Clear filters on category change
  }, [itemName, dataKey, searchQuery]);

  // Function to fetch product data based on current filters and sort options
  const fetchProducts = async (currentFilters, currentSortOption) => {
    const url2 = `${API_URL}/${window.ENV.TENANT_NAME}/${window.ENV.DATA_SOURCE}/data`;
    const convertedFilteredData = {};
    currentFilters?.forEach((item) => {
      convertedFilteredData[item.name.replaceAll(" ", "_").toLowerCase()] =
        item.values;
    });

    let requestBody2 = {
      range: "Product!A1:" + window.ENV.TOTAL_PRODUCTS,
      dataKey: dataKey,
      filters: {
        ...convertedFilteredData,
      },
    };

    // If it's a search query, don't filter by category
    if (!searchQuery && itemName !== 'search') {
      requestBody2.filters.categoryName = [itemName];
    }

    if (currentSortOption && currentSortOption !== "1") {
      let sortOrder = "";
      let sortAttribute = "";

      if (currentSortOption?.includes("-asc")) {
        sortOrder = "ASC";
      } else if (currentSortOption?.includes("-desc")) {
        sortOrder = "DESC";
      }

      const selectedFilter = currentSortOption?.split('-')[0];
      sortAttribute = selectedFilter.replaceAll(" ", "_").toLowerCase();

      requestBody2 = {
        ...requestBody2,
        sortAttribute: sortAttribute,
        sortOrder: sortOrder,
      };
    }

    try {
      console.log("API Request Body:", requestBody2);
      const response = await axios.post(url2, requestBody2, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("API Response:", response.data);
      setLocalProductData(response.data);
      setFilteredProductData(response.data);
    } catch (error) {
      const errorMessage = error.response
        ? error.response.data
        : error.message;
      console.error("Error in Product API: ", errorMessage);
      setError(errorMessage || "An error occurred while fetching products.");
    }
  };

  // Fetch products when filters or sort option change
  useEffect(() => {
    fetchProducts(filter, selectedOption);
  }, [filter, selectedOption, itemName, dataKey, searchQuery]);

  // Filter products based on search query
  useEffect(() => {
    console.log("Filtering - searchQuery:", searchQuery, "localProductData length:", localProductData.length);
    
    if (searchQuery) {
      if (localProductData.length > 0) {
        const filteredProducts = localProductData.filter(product => {
          // Search in productId, categoryName, and other relevant fields
          const searchLower = searchQuery.toLowerCase();
          // For debugging, let's only check productId first
          const matches = product.productId && product.productId.toLowerCase().includes(searchLower);
          console.log(`Product ${product.productId}: matches=${matches} for search "${searchLower}"`);
          return matches;
        });
        console.log("filteredProducts count:", filteredProducts.length);
        setFilteredProductData(filteredProducts);
      } else {
        // No products to filter
        setFilteredProductData([]);
      }
    } else {
      // No search query, show all products
      setFilteredProductData(localProductData);
    }
  }, [searchQuery, localProductData]);

  const handleSortOnChange = (newSelectedOption) => {
    setSelectedOption(newSelectedOption);
    // fetchProducts will be called by useEffect when selectedOption changes
  };

  const handleFilterAdd = (filterName, valueToAdd) => {
    let otherFilters = filter?.filter((item) => item.name !== filterName);
    let selectedFilterAllValues =
      filter?.filter((item) => item.name === filterName).length === 0
        ? []
        : filter?.filter((item) => item.name === filterName)[0]?.values.slice();

    selectedFilterAllValues.push(valueToAdd);

    let overwrittenObj = { name: filterName, values: selectedFilterAllValues };
    otherFilters.push(overwrittenObj);

    setFilter(otherFilters);
    // fetchProductData(otherFilters); // Redundant, useEffect will handle
  };

  const handleFilterDelete = (filterName, valueToRemove) => {
    let updatedFilters = filter?.map((item) => {
      if (item.name === filterName) {
        return {
          ...item,
          values: item.values.filter((val) => val !== valueToRemove),
        };
      }
      return item;
    }).filter(item => item.values.length > 0); // Remove filter if no values left

    setFilter(updatedFilters);
    // fetchProductData(updatedFilters); // Redundant, useEffect will handle
  };

  const handleSelectFilter = (filterName, value, isChecked) => {
    if (isChecked) {
      handleFilterAdd(filterName, value);
    } else {
      handleFilterDelete(filterName, value);
    }
  };

  const checkCurrentItemIsFiltered = (filterName, filterValue) => {
    return filter?.some(filterDataStoreItem =>
      filterDataStoreItem.name === filterName &&
      filterDataStoreItem.values.includes(filterValue)
    );
  };

  const handleClearAllFilter = () => {
    setFilter([]);
    setMobileFilterOpen(false); // Close mobile filter after clearing
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const toggleShowMore = (name) => {
    setShowMoreState((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  useEffect(() => {
    if (modalState && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setModalPosition({ top: rect.bottom, left: rect.left });
    }
  }, [modalState]);

  const handleOpen = (itemName) => {
    const rect = buttonRef.current.getBoundingClientRect();
    setModalPosition({ top: rect.bottom, left: rect.left });
    setModalState(itemName);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleRemoveFilter = (name, value) => {
    handleFilterDelete(name, value)
  };

  const handleCompareClick = () => {
    if (compareProducts.length > 1) {
      navigate("/compare/:categoryName", { state: { itemName } });
    } else {
      console.log("Please select at least two products to compare.");
    }
  };

  const handleClearCompare = () => {
    setCompareProducts([]);
  };

  const [view, setView] = useState("grid");

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setView(newView);
    }
  };

  // Mobile filter functions
  const toggleMobileFilter = () => {
    setMobileFilterOpen((prev) => {
      if (!prev) setMobileSortOpen(false); // If opening filter, close sort
      return !prev;
    });
    setActiveMobileFilter(null);
  };

  // Mobile sort functions
  const toggleMobileSort = () => {
    setMobileSortOpen((prev) => {
      if (!prev) setMobileFilterOpen(false); // If opening sort, close filter
      return !prev;
    });
  };

  const scrollToFilter = (filterName) => {
    if (filterRefs.current[filterName]) {
      filterRefs.current[filterName].scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Mainlayout categoryName={searchQuery ? `Search Results for "${searchQuery}"` : itemName}>
      <div className="productlist-container">
        {/* Desktop Filter Section */}
        <div className="filter-left-main-container ">
          {filterData?.map((item) => (
            <Accordian key={item.name}>
              <h3 className="Accordian-title">{item.name}</h3>
              <div className="checkbox-container ">
                <div
                  className="listoful"
                  style={{
                    maxHeight: "210px",
                    overflowY: "auto",
                    padding: "5px",
                  }}
                >
                  {item.options.map((option, index) => (
                    <div key={index}>
                      <input
                        type="checkbox"
                        name={item.name}
                        onChange={(eventArgs) =>
                          handleSelectFilter(
                            item.name,
                            option.label,
                            eventArgs.target.checked
                          )
                        }
                        value={option.label}
                        checked={checkCurrentItemIsFiltered(item.name, option.label)}
                      />
                      &nbsp;
                      {item.name === "Color" ? (
                        <span
                          style={{
                            backgroundColor: option.label,
                            width: "15px",
                            height: "15px",
                            borderRadius: "50%",
                            display: "inline-block",
                          }}
                        ></span>
                      ) : null}
                      &nbsp;
                      <label className="filter-left-label">
                        {option.labelWithCount}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </Accordian>
          ))}

          <Modal open={open} onClose={handleClose}>
            <Box sx={style(modalPosition.top, modalPosition.left)}>
              <TextField
                size="small"
                label="Search"
                variant="outlined"
                fullWidth
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{
                  marginBottom: "11px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "4px",
                  fontSize: "10px",
                }}
              />
              <div>
                {filterData
                  .filter((item) => item.name === "Price Range")
                  .flatMap((item) =>
                    item.options.map((i, index) => (
                      <div key={index}>
                        <input
                          type="checkbox"
                          name={item.name}
                          onChange={(eventArgs) =>
                            handleSelectFilter(
                              item.name,
                              i.label,
                              eventArgs.target.checked
                            )
                          }
                          value={i.label}
                          checked={checkCurrentItemIsFiltered(item.name, i.label)}
                        />
                        &nbsp;
                        {item.name === "Color" ? (
                          <span
                            style={{
                              backgroundColor: i.label,
                              width: "15px",
                              height: "15px",
                              borderRadius: "50%",
                              display: "inline-block",
                            }}
                          ></span>
                        ) : null}
                        &nbsp;
                        <label className="filter-left-label">{i.label}</label>
                      </div>
                    ))
                  )}
              </div>
            </Box>
          </Modal>
        </div>

        {/* Mobile Filter and Sort Buttons */}
        {!searchQuery && (
        <div className="mobile-buttons-container">

          <button
            className="mobile-filter-toggle"
            onClick={toggleMobileFilter}
          >
            <FaFilter /> Filters
          </button>
          <button
            className="mobile-sort-toggle"
            onClick={toggleMobileSort}
          >
            <FaSort /> Sort By
          </button>
          
        </div>
        )}

        {/* Mobile Filter Drawer */}
        {mobileFilterOpen && (
          <div className={`mobile-drawer${mobileFilterOpen ? ' open' : ''}`}>
            <div className="mobile-drawer-header">
              <h3>Filters</h3>
              <button onClick={toggleMobileFilter}>
                <GrFormClose size={20} />
              </button>
            </div>
            <div className="mobile-drawer-content">
              <div className="filter-categories">
                {filterData?.map((item) => (
                  <button
                    key={item.name}
                    className={`filter-category-btn ${activeMobileFilter === item.name ? 'active' : ''}`}
                    onClick={() => {
                      setActiveMobileFilter(activeMobileFilter === item.name ? null : item.name);
                      scrollToFilter(item.name);
                    }}
                  >
                    {item.name}
                    {filter?.some(f => f.name === item.name) && (
                      <span className="filter-indicator"></span>
                    )}
                  </button>
                ))}
              </div>

              <div className="mobile-filter-sections">
                {filterData?.map((item) => (
                  <div
                    key={item.name}
                    className="mobile-filter-section"
                    ref={el => filterRefs.current[item.name] = el}
                  >
                    <h4>{item.name}</h4>
                    <div className="mobile-filter-options">
                      {item.options.map((option, index) => (
                        <div key={index} className="mobile-filter-option">
                          <input
                            type="checkbox"
                            id={`mobile-${item.name}-${index}`}
                            name={item.name}
                            onChange={(eventArgs) =>
                              handleSelectFilter(
                                item.name,
                                option.label,
                                eventArgs.target.checked
                              )
                            }
                            value={option.label}
                            checked={checkCurrentItemIsFiltered(item.name, option.label)}
                          />
                          <label htmlFor={`mobile-${item.name}-${index}`}>
                            {item.name === "Color" && (
                              <span
                                className="color-swatch"
                                style={{ backgroundColor: option.label }}
                              />
                            )}
                            {option.labelWithCount}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mobile-drawer-footer">
              <button onClick={handleClearAllFilter}>Clear All</button>
              <button onClick={toggleMobileFilter}>Apply Filters</button>
            </div>
          </div>
        )}

        {/* Mobile Sort Drawer */}
        {mobileSortOpen && (
          <div className={`mobile-drawer${mobileSortOpen ? ' open' : ''}`}>
            <div className="mobile-drawer-header">
              <h3>Sort By</h3>
              <button onClick={toggleMobileSort}>
                <GrFormClose size={20} />
              </button>
            </div>
            <div className="mobile-drawer-content">
                
              <div className="mobile-filter-options" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {/* Sort By default option */}
                <div className="mobile-filter-option">
                  <input
                    type="radio"
                    id="mobile-sort-default"
                    name="mobile-sort"
                    value="1"
                    checked={tempSelectedSort === "1"}
                    onChange={() => setTempSelectedSort("1")}
                  />
                  <label htmlFor="mobile-sort-default">Sort By</label>
                </div>
                {/* Dynamically generate sort options from filterData */}
                {filterData?.map((item) => [
                  <div className="mobile-filter-option" key={`${item.name}-asc`}>
                    <input
                      type="radio"
                      id={`mobile-sort-${item.name}-asc`}
                      name="mobile-sort"
                      value={`${item.name}-asc`}
                      checked={tempSelectedSort === `${item.name}-asc`}
                      onChange={() => setTempSelectedSort(`${item.name}-asc`)}
                    />
                    <label htmlFor={`mobile-sort-${item.name}-asc`}>
                      {item.name} Low to High
                    </label>
                  </div>,
                  <div className="mobile-filter-option" key={`${item.name}-desc`}>
                    <input
                      type="radio"
                      id={`mobile-sort-${item.name}-desc`}
                      name="mobile-sort"
                      value={`${item.name}-desc`}
                      checked={tempSelectedSort === `${item.name}-desc`}
                      onChange={() => setTempSelectedSort(`${item.name}-desc`)}
                    />
                    <label htmlFor={`mobile-sort-${item.name}-desc`}>
                      {item.name} High to Low
                    </label>
                  </div>
                ])}
              </div>
            </div>
            <div className="mobile-drawer-footer">
              <button
                onClick={() => {
                  setTempSelectedSort("1");
                  setSelectedOption("1");
                  setMobileSortOpen(false);
                }}
                style={{ background: tempSelectedSort === "1" ? '#e0e0ff' : undefined }}
              >
                Clear Sort
              </button>
              <button
                onClick={() => {
                  setSelectedOption(tempSelectedSort);
                  setMobileSortOpen(false);
                }}
                style={{ background: '#222', color: '#fff' }}
              >
                Apply
              </button>
            </div>
          </div>
        )}

        <div className="right-section">
          <div className="filter-display">
            <div className="selected-filters">
              {filter?.map((item) =>
                item?.values?.map((innerItem, index) => (
                  <div className="filter-badges" key={`${item.name}-${innerItem}`}>
                    <div key={index} className="filter-badge">
                      {innerItem}
                      <GrFormClose
                        className="removemark"
                        onClick={() => handleRemoveFilter(item.name, innerItem)}
                      />
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          {isDesktop && (
            <hr className="hrtop" />
          )}

          {isDesktop && (
            <>
              <div className="filter-options">
                <MyButtonGroup>
                  <ToggleButtonGroup
                    value={view}
                    exclusive
                    onChange={handleViewChange}
                    aria-label="View toggle"
                  >
                    <ToggleButton
                      value="grid"
                      aria-label="Grid View"
                      sx={{
                        padding: "2px 3px",
                        fontSize: "14px",
                        backgroundColor: view === "grid" ? "#cce5ff" : "#f0f0f0",
                        color: view === "grid" ? window.ENV.GENERAL.BACKGROUND_COLOR : "#000",
                        borderRadius: "0px",
                        "&.Mui-selected": {
                          backgroundColor: "#cce5ff",
                          color: window.ENV.GENERAL.BACKGROUND_COLOR,
                        },
                        "&:hover": {
                          backgroundColor: "#e6f0ff",
                        },
                      }}
                    >
                      <ViewModuleIcon />
                    </ToggleButton>

                    <ToggleButton
                      value="list"
                      aria-label="List View"
                      sx={{
                        padding: "2px 3px",
                        fontSize: "14px",
                        backgroundColor: view === "list" ? "#cce5ff" : "#f0f0f0",
                        color: view === "list" ? window.ENV.GENERAL.BACKGROUND_COLOR : "#000",
                        borderRadius: "0px",
                        "&.Mui-selected": {
                          backgroundColor: "#cce5ff",
                          color: window.ENV.GENERAL.BACKGROUND_COLOR,
                        },
                        "&:hover": {
                          backgroundColor: "#e6f0ff",
                        },
                      }}
                    >
                      <ViewListIcon />
                    </ToggleButton>
                  </ToggleButtonGroup>

                  {!searchQuery && (
                  <MyButton
                    onClick={handleClearAllFilter}
                    name="Clear Filter"
                    marginBottom="15px"
                  />
                  )}

                  {window.ENV.SHOW_COMPARE && (
                    <>
                      <MyButton
                        onClick={handleCompareClick}
                        name={`Compare (${compareProducts.length})`}
                        marginBottom="15px"
                      />
                      <MyButton
                        onClick={handleClearCompare}
                        name="Clear Compare"
                        marginBottom="15px"
                      />
                    </>
                  )}
                </MyButtonGroup>

                {/* Desktop Sort By dropdown - only visible on desktop */}
                {!searchQuery && (
                <div className="desktop-sort-dropdown">
                  <MySelect
                    defaultValue="1"
                    categoryName={itemName}
                    datas={filterData}
                    type="productList"
                    onSelectChange={handleSortOnChange}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                  />
                </div>
                )}
              </div>
            </>
          )}


          <div className="product-grid">
            {productError || error ? (
              <div className="error-message">{productError || error}</div>
            ) : (
              <>
                {/* Search Results Header */}
                {searchQuery && (
                  <div className="search-results-header">
                    <h3>
                      Search by: <span style={{ fontWeight: 'bold' }}>"{searchQuery}"</span>
                    </h3>
                    <p>
                      {filteredProductData.length} {filteredProductData.length === 1 ? 'item' : 'items'} found
                    </p>
                  </div>
                )}
                
                <div className="category-grid-container">
                {filteredProductData.length > 0 ? (
                  view === "grid" ? (
                    filteredProductData.map((product) =>
                      window.ENV.PRODUCT_LIST_LAYOUT == "imageOnLeft" ? (
                        <ImageOnLeft
                          product={product}
                          categoryName={itemName}
                          key={product.id} // Added key for list rendering
                          specifications={filteredProductData[0]?.tableViewColumns}
                        />
                      ) : (
                        <ImageOnTop product={product} key={product.id} /> // Added key
                      )
                    )
                  ) : (
                    <ListView
                      products={filteredProductData}
                      categoryName={itemName}
                      tableViewColumns={filteredProductData[0]?.tableViewColumns}
                    />
                  )
                ) : (
                  <p className="loading">No Products</p>
                )}
              </div>
              </>
            )}
          </div>
        </div>
      </div>
    </Mainlayout>
  );
};

export default Productlist;